(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-calendario-disney"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prepareDisneyCalendarVideos() {
      document.querySelectorAll('.pd-calendar-disney__video').forEach(function (video) {
        if (video.dataset.pdDisneyReady === 'true') return;
        video.dataset.pdDisneyReady = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
        video.removeAttribute('controls');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        function playVideo() {
          video.muted = true;
          var promise = video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        }

        video.addEventListener('loadeddata', playVideo, { once: true });
        video.addEventListener('canplay', playVideo);
        window.addEventListener('pageshow', playVideo);
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) playVideo();
        });
        playVideo();
      });
    }

    prepareDisneyCalendarVideos();
    document.addEventListener('shopify:section:load', prepareDisneyCalendarVideos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloque-acrilico-pixel-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prepareVideos() {
      document.querySelectorAll('.pd-pixar-plaque-banner__video').forEach(function (video) {
        if (video.dataset.picsdayReady === 'true') return;
        video.dataset.picsdayReady = 'true';
        video.muted = true;
        video.defaultMuted = true;
        video.volume = 0;
        video.removeAttribute('controls');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        function playVideo() {
          video.muted = true;
          var promise = video.play();
          if (promise && typeof promise.catch === 'function') {
            promise.catch(function () {});
          }
        }

        video.addEventListener('loadeddata', playVideo, { once: true });
        video.addEventListener('canplay', playVideo);
        window.addEventListener('pageshow', playVideo);
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) playVideo();
        });
        playVideo();
      });
    }

    prepareVideos();
    document.addEventListener('shopify:section:load', prepareVideos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-picsday"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initialiseProductCarousels() {
      document.querySelectorAll('.pd-product-carousel').forEach(function (carousel) {
        if (carousel.dataset.initialised === 'true') return;
        carousel.dataset.initialised = 'true';

        var track = carousel.querySelector('.pd-product-carousel__track');
        var slides = Array.prototype.slice.call(carousel.querySelectorAll('.pd-product-carousel__slide'));
        var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
        var previous = carousel.querySelector('[data-carousel-prev]');
        var next = carousel.querySelector('[data-carousel-next]');
        var delay = Number(carousel.dataset.delay) || 7000;
        var current = 0;
        var timer;

        if (!track || !slides.length) return;

        function playActiveVideo() {
          slides.forEach(function (slide, index) {
            var video = slide.querySelector('.pd-product-carousel__video');
            if (!video) return;
            video.muted = true;
            video.defaultMuted = true;
            video.removeAttribute('controls');
            video.setAttribute('playsinline', '');
            video.setAttribute('webkit-playsinline', '');

            if (index !== current) {
              video.pause();
              return;
            }

            var promise = video.play();
            if (promise && typeof promise.catch === 'function') {
              promise.catch(function () {
                slide.classList.add('is-video-blocked');
              });
            }
          });
        }

        function showSlide(index) {
          current = (index + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + (current * 100) + '%)';
          slides.forEach(function (slide, slideIndex) {
            slide.classList.toggle('is-active', slideIndex === current);
          });
          dots.forEach(function (dot, dotIndex) {
            var selected = dotIndex === current;
            dot.classList.toggle('is-active', selected);
            dot.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
          playActiveVideo();
        }

        function restartTimer() {
          window.clearInterval(timer);
          if (slides.length > 1) {
            timer = window.setInterval(function () { showSlide(current + 1); }, delay);
          }
        }

        if (previous) previous.addEventListener('click', function () { showSlide(current - 1); restartTimer(); });
        if (next) next.addEventListener('click', function () { showSlide(current + 1); restartTimer(); });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () { showSlide(Number(dot.dataset.carouselDot)); restartTimer(); });
        });

        slides.forEach(function (slide) {
          var video = slide.querySelector('.pd-product-carousel__video');
          var playButton = slide.querySelector('[data-video-play]');
          if (!video) return;
          video.addEventListener('playing', function () { slide.classList.remove('is-video-blocked'); });
          video.addEventListener('pause', function () {
            if (slide.classList.contains('is-active') && !video.ended) slide.classList.add('is-video-blocked');
          });
          if (playButton) {
            playButton.addEventListener('click', function () {
              video.muted = true;
              video.play().then(function () { slide.classList.remove('is-video-blocked'); }).catch(function () {});
            });
          }
        });

        carousel.addEventListener('mouseenter', function () { window.clearInterval(timer); });
        carousel.addEventListener('mouseleave', restartTimer);
        carousel.addEventListener('touchstart', function () { window.clearInterval(timer); }, { passive: true });
        carousel.addEventListener('touchend', restartTimer, { passive: true });
        window.addEventListener('pageshow', function () { showSlide(current); });
        document.addEventListener('visibilitychange', function () { if (!document.hidden) showSlide(current); });

        showSlide(0);
        restartTimer();
      });
    }

    initialiseProductCarousels();
    document.addEventListener('shopify:section:load', initialiseProductCarousels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
